module.exports = __webpack_public_path__ + "img/foto1.a1d731a5.webp";